import { forwardRef } from 'react';

import { inputClasses } from '@mui/material/Input';
import type { InputProps as MuiInputProps } from '@mui/material/Input';

import { StyledInput } from './Input.style';

type InputProps = {
  variant?: 'standard' | 'underline';
} & Omit<MuiInputProps, 'disableUnderline'>;

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ variant = 'standard', ...rest }, ref) => (
    <StyledInput
      disableUnderline
      ref={ref}
      spellCheck={false}
      variant={variant}
      {...rest}
    />
  )
);

export type { InputProps };
export { inputClasses };
export default Input;
